export default __webpack_public_path__ + "static/media/4e64c92266daea70f6de61d1043f07d8.png";